// extracted by mini-css-extract-plugin
export default {"dropdown":"DistrictsDropdown_dropdown__b9niI","dropdown_wrapper":"DistrictsDropdown_dropdown_wrapper__muQRW"};